<header class="site-header">
  <div class="header-row">
    <button
      type="button"
      class="burger"
      (click)="toggleMenu()"
      [attr.aria-expanded]="menuOpen()"
      [attr.aria-label]="'nav.allSite' | translate">
      <app-icon name="menu" [size]="20" />
    </button>

    <a class="brand" [routerLink]="'home' | localizedLink">
      <img class="brand-logo" src="/img/pokemon-go-laval-logo.webp" alt="Pokémon GO Laval" width="42" height="42" />
      <span class="brand-wordmark">
        <span class="brand-name">Pokémon GO</span>
        <span class="brand-city">Laval</span>
      </span>
    </a>

    <nav class="desktop-nav">
      @for (item of primaryNav; track item.routeKey) {
        <a
          class="nav-pill"
          [routerLink]="item.routeKey | localizedLink"
          routerLinkActive="is-active"
          [routerLinkActiveOptions]="{ exact: !!item.exact }">
          {{ item.labelKey | translate }}
        </a>
      }
      <button type="button" class="nav-pill nav-pill-button" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen()">
        {{ 'nav.allSite' | translate }}
        <app-icon class="caret" name="chevron-down" [size]="14" />
      </button>
    </nav>

    <div class="header-spacer"></div>

    <div class="header-actions">
      <button type="button" class="search-pill" (click)="searchService.open()">
        <app-icon class="search-pill-glyph" name="search" [size]="16" />
        <span class="search-pill-label">{{ 'search.placeholder' | translate }}</span>
        <span class="search-pill-key">{{ searchService.shortcutHint() }}</span>
      </button>

      <div class="header-settings">
        <app-language-switcher />
        <app-theme-toggle />
      </div>
      <app-profile-menu />

      <app-dropdown class="social" #socialDropdown="appDropdown">
        <button
          dropdownTrigger
          type="button"
          class="social-trigger"
          (click)="toggleSocial()"
          [attr.aria-expanded]="socialDropdown.open()"
          [attr.aria-label]="'nav.social.join' | translate">
          <img class="social-trigger-icon" src="/icons/discord.svg" width="18" height="18" alt="" />
          <span class="social-label">{{ 'nav.social.join' | translate }}</span>
          <app-icon class="caret" name="chevron-down" [size]="14" />
        </button>
        <div dropdownPanel class="social-panel" [class.social-panel--open]="socialDropdown.open()">
          @for (link of socialLinks; track link.key) {
            <a class="social-row" [href]="link.url" target="_blank" rel="noreferrer" (click)="trackSocialCta(link.key)">
              <span class="social-tile social-tile-{{ link.key }}">
                <img src="/icons/{{ link.key }}.svg" width="19" height="19" alt="" />
              </span>
              <span class="social-row-text">
                <span class="social-row-label">{{ link.labelKey | translate }}</span>
                <span class="social-row-sub">{{ link.subKey | translate }}</span>
              </span>
            </a>
          }
        </div>
      </app-dropdown>
    </div>
  </div>

  <div class="mega-menu" [class.mega-menu--open]="menuOpen()">
    <div class="mega-menu-inner">
      <div class="mega-mobile-settings">
        <app-language-switcher [native]="true" />
        <app-theme-toggle />
      </div>

      <div class="mega-mobile-nav">
        @for (item of mobileNav; track item.routeKey) {
          <a class="mobile-pill" [routerLink]="item.routeKey | localizedLink" (click)="closeMenu()">
            {{ item.labelKey | translate }}
          </a>
        }
        <a class="mobile-pill mobile-pill-accent" [routerLink]="'profile' | localizedLink" (click)="closeMenu()">
          {{ 'nav.myProfile' | translate }}
        </a>
      </div>

      <div class="mega-grid">
        @for (column of megaMenuColumns; track column.headerKey) {
          <div class="mega-column">
            <span class="mega-column-header">{{ column.headerKey | translate }}</span>
            @for (link of column.links; track $index) {
              <a class="mega-link" [routerLink]="link.routeKey | localizedLink" (click)="closeMenu()">
                {{ link.labelKey | translate }}
              </a>
            }
            @if (column.headerKey === 'megaMenu.contribute') {
              <a class="mega-link" [href]="discordInviteUrl" target="_blank" rel="noreferrer">
                {{ 'nav.reportError' | translate }}
              </a>
            }
          </div>
        }

        <a
          class="mega-promo"
          [routerLink]="'calendar' | localizedLink"
          [queryParams]="promoEvent() ? { event: promoEvent()!.id } : {}"
          (click)="trackPromoClick(); closeMenu()">
          <span class="mega-promo-eyebrow">{{ 'megaMenu.promo.eyebrow' | translate }}</span>
          @if (promoEvent(); as event) {
            <span class="mega-promo-main">
              @if (event.image_url && !promoImageFailed()) {
                <img
                  appImageFade
                  class="mega-promo-img"
                  [src]="event.image_url"
                  alt=""
                  width="64"
                  height="64"
                  (error)="onPromoImageError()" />
              }
              <span class="mega-promo-text">
                <span class="mega-promo-title">{{ event.title }}</span>
                <span class="mega-promo-date">{{ formatPromoDate(event) }}</span>
              </span>
            </span>
          } @else {
            <span class="mega-promo-date">{{ 'megaMenu.promo.empty' | translate }}</span>
          }
          <span class="mega-promo-cta">{{ 'megaMenu.promo.cta' | translate }}</span>
        </a>
      </div>
    </div>
  </div>

  @if (!hideSearchFab()) {
    <button
      type="button"
      class="search-fab"
      (click)="searchService.open()"
      [attr.aria-label]="'search.placeholder' | translate">
      <app-icon name="search" [size]="20" />
    </button>
  }
</header>
